import { conformArrayResponse, conformObjectResponse } from '~/api/utils';
import { axiosInstance } from '~/api/config/axios.config';
import { MoneyListItemDto } from '~/models/contract.dto';
import { TeamCodeList } from '~/models/team/TeamCodeList.dto';
import { ContactsCreateList } from '~/models/contacts.dto';
export class ContractApi {
    static async getContracts(ProjectId: number) {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectCreator/money', { params: { ProjectId } }), MoneyListItemDto);
    }
    static async createNewContact(data: any) {
        //return data;

        return conformObjectResponse(axiosInstance.post('/catalogue/projectContact/project/save', data), ContactsCreateList);
        // return axiosInstance.post('/catalogue/projectContact/project/save', data);
    }

    static async getContractTypeList() {
        return conformArrayResponse(axiosInstance.get('/catalogue/projectReference/list?type=contacttype'), TeamCodeList);
    }
}
